import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, map, mergeMap, of, withLatestFrom } from 'rxjs';
import { AuthFacade } from '~app/app/~store/facades/auth.facade';
import { SnackbarService } from '~app/app/~shared/services/snackbar.service';

export const AUTHENTICATED_GUARD = (
  route: ActivatedRouteSnapshot,
  next: RouterStateSnapshot
): Observable<UrlTree | boolean> => {
  const requestedUrl = next.url;
  const authFacade = inject(AuthFacade);
  const snackbarService = inject(SnackbarService);
  const router = inject(Router);
  return authFacade.accessToken$.pipe(
    withLatestFrom(authFacade.currentUser$),
    mergeMap(([accessToken, currentUser]) => {
      // if (currentUser && !currentUser.passwordChanged) {
      //   snackbarService.open({
      //     text: `Vous n'avez pas défini de mot de passe. Veuillez consulter votre adresse mail.`
      //   });
      //   return authFacade.logout();
      // }
      return of(accessToken);
    }),
    map(accessToken => {
      if (!accessToken) {
        authFacade.setLastRequestedRoute(requestedUrl);
        return router.createUrlTree(['/signin']);
      }
      return true;
    })
  );
};
